import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_BY_TRIAL_GROUP_LABORATORY_ID,
    ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_BY_ID,

    ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE,

    ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE,

    ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE,

    ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE,

    ITrialGroupLaboratoryContractLoadByTrialGroupLaboratoryIdAction,
    ITrialGroupLaboratoryContractLoadByIdAction,
    ITrialGroupLaboratoryContractLoadFailureAction,
    ITrialGroupLaboratoryContractLoadSuccessAction,

    ITrialGroupLaboratoryContractSaveAction,
    ITrialGroupLaboratoryContractSaveSuccessAction,
    ITrialGroupLaboratoryContractSaveFailureAction,

    ITrialGroupLaboratoryContractCreateAction,
    ITrialGroupLaboratoryContractCreateSuccessAction,
    ITrialGroupLaboratoryContractCreateFailureAction,

    ITrialGroupLaboratoryContractDeleteAction,
    ITrialGroupLaboratoryContractDeleteSuccessAction,
    ITrialGroupLaboratoryContractDeleteFailureAction,

    ITrialGroupLaboratoryContractValidateAction,
    ITrialGroupLaboratoryContractValidateSuccessAction,
    ITrialGroupLaboratoryContractValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    DeleteSuccess,
    DeleteFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialGroupLaboratoryContract";
import { trialGroupLaboratoryContractApi } from "../services/trialGroupLaboratoryContract";

export const
    getTrialGroupLaboratoryContractByTrialGroupLaboratoryIdEpic = (action$): Observable<ITrialGroupLaboratoryContractLoadSuccessAction | ITrialGroupLaboratoryContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_BY_TRIAL_GROUP_LABORATORY_ID)
            .mergeMap((action: ITrialGroupLaboratoryContractLoadByTrialGroupLaboratoryIdAction) => {
                return trialGroupLaboratoryContractApi
                    .getTrialGroupLaboratoryContractByTrialGroupLaboratoryId(action.trialGroupLaboratoryId)
                    .map(response =>
                        LoadSuccess(response.trialGroupLaboratoryContract, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupLaboratoryContractByIdEpic = (action$): Observable<ITrialGroupLaboratoryContractLoadSuccessAction | ITrialGroupLaboratoryContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYCONTRACT_LOAD_BY_ID)
            .mergeMap((action: ITrialGroupLaboratoryContractLoadByIdAction) => {
                return trialGroupLaboratoryContractApi
                    .getTrialGroupLaboratoryContractById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialGroupLaboratoryContract, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialGroupLaboratoryContractEpic = (action$): Observable<ITrialGroupLaboratoryContractSaveSuccessAction | ITrialGroupLaboratoryContractSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYCONTRACT_SAVE)
            .mergeMap((action: ITrialGroupLaboratoryContractSaveAction) => {
                return trialGroupLaboratoryContractApi
                    .setTrialGroupLaboratoryContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialGroupLaboratoryContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialGroupLaboratoryContractEpic = (action$): Observable<ITrialGroupLaboratoryContractCreateSuccessAction | ITrialGroupLaboratoryContractCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYCONTRACT_CREATE)
            .mergeMap((action: ITrialGroupLaboratoryContractCreateAction) => {
                return trialGroupLaboratoryContractApi
                    .createTrialGroupLaboratoryContract(action.trialGroupLaboratoryId)
                    .map(response =>
                        CreateSuccess(
                            response.trialGroupLaboratoryContract,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialGroupLaboratoryContractEpic = (action$): Observable<ITrialGroupLaboratoryContractValidateSuccessAction | ITrialGroupLaboratoryContractValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYCONTRACT_VALIDATE)
            .mergeMap((action: ITrialGroupLaboratoryContractValidateAction) => {
                return trialGroupLaboratoryContractApi
                    .validateTrialGroupLaboratoryContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialGroupLaboratoryContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    },
    deleteTrialGroupLaboratoryContractEpic = (action$): Observable<ITrialGroupLaboratoryContractDeleteSuccessAction | ITrialGroupLaboratoryContractDeleteFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYCONTRACT_DELETE)
            .mergeMap((action: ITrialGroupLaboratoryContractDeleteAction) => {
                return trialGroupLaboratoryContractApi
                    .deleteTrialGroupLaboratoryContract(action.id)
                    .map(_response =>
                        DeleteSuccess()
                    )
                    .catch(error =>
                        Observable.of(DeleteFailure(error.responseStatus))
                    )
            });
    }